<template>
  <div class="container">
    <el-input placeholder="Ej: -33.4388825,-70.676444"
              class="greenAppend"
              v-model="text">
      <el-button @click="setLatLng"
                 slot="append"
                 icon="fa fa-search">
      </el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'InputSearchByPosition',
  data() {
    return {
      location: this.value,
      position: {},
      text: '',
    };
  },
  props: {
    value: {
      type: Object,
    },
  },
  methods: {
    isLatitude(lat) {
      // eslint-disable-next-line no-restricted-globals
      return isFinite(lat) && Math.abs(lat) <= 90;
    },
    isLongitude(lng) {
      // eslint-disable-next-line no-restricted-globals
      return isFinite(lng) && Math.abs(lng) <= 180;
    },
    setLatLng() {
      let latAux = 0;
      let lngAux = 0;
      const positionSplitted = this.text.split(',');
      if (positionSplitted.length === 2) {
        const lat = positionSplitted[0];
        const lng = positionSplitted[1];
        const latNum = parseFloat(lat);
        const lngNum = parseFloat(lng);
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(latNum)) {
          if (this.isLatitude(latNum)) {
            latAux = latNum;
          }
        } else {
          return;
        }
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(lngNum)) {
          if (this.isLongitude(lngNum)) {
            lngAux = lngNum;
          }
        } else {
          return;
        }
        this.position = {
          lat: latAux,
          lng: lngAux,
        };
        this.$emit('setPosition', this.position);
      }
    },
  },
  mounted() {
    this.text = this.formatedText;
  },
  computed: {
    formatedText() {
      // `this` points to the vm instance
      const lat = this.value.position.lat.toString();
      const lng = this.value.position.lng.toString();
      return ''.concat(lat, ', ', lng);
    },
  },
  watch: {
    formatedText(val) { this.text = val; },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    margin-top: 0.3em;
    margin-bottom: 0.5em;
  }
</style>
